import { ArrowTopRightThickIcon } from './ArrowTopRightThickIcon';

/**
 * author: Michael Irigoyen
 * id 37C83BAE-6330-4E45-A976-3E2642997035
 * name arrow-top-right-thick
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-right-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowTopRightBoldIcon = ArrowTopRightThickIcon;
export default ArrowTopRightBoldIcon